import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidKlankSwitch } from '../../../../mechanics/rid-klank-switch/rid-klank-switch';

@Component({
  selector: 'app-klank-switch-page',
  imports: [RidKlankSwitch],
  templateUrl: './klank-switch-page.html',
})
export class KlankSwitchPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly router = inject(Router);

  protected readonly shuffle = () => parseInt(this.$activatedRoute.snapshot.queryParams['shuffle'] ?? '1');
}
